// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { AddressDTO } from '../models';
import { CreateOrganizationDTO } from '../models';
import { LandlordDTO } from '../models';
import { OrganizationCashDepositSchemeDTO } from '../models';
import { OrganizationDTO } from '../models';
import { OrganizationMetricsDTO } from '../models';
import { OrganizationRecipientDTO } from '../models';
import { OrganizationUserDTO } from '../models';
import { OrganizationVerticalDTO } from '../models';
import { OrganizationWithCashDepositDTO } from '../models';
import { PropertyDTO } from '../models';
import { SearchHubspotCompaniesResultsDTO } from '../models';
import { SearchOrganizationResultsDTO } from '../models';
import { TenancyDTO } from '../models';
import { UpdateOrganizationAddressDTO } from '../models';
import { UpdateOrganizationCommissionRuleDTO } from '../models';
import { UpdateOrganizationDTO } from '../models';
import { UpdateOrganizationHubspotIdDTO } from '../models';
import { UpdateOrganizationInventoryConfirmationDelayDTO } from '../models';
import { UpdateOrganizationNameDTO } from '../models';
import { UpdateOrganizationNotesDTO } from '../models';
import { UpdateOrganizationParentGroupsDTO } from '../models';
import { UpdateOrganizationPolicyCoverCapDTO } from '../models';
import { UpdateOrganizationPricingRuleDTO } from '../models';
import { UpdateYourCompanyDTO } from '../models';
import { UserDTO } from '../models';
/**
 * OrganizationsApi - axios parameter creator
 * @export
 */
export const OrganizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Confirm bank accounts collected through onboarding
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmBankAccounts(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling confirmBankAccounts.');
            }
            const localVarPath = `/v2/organizations/{id}/onboarding/bank-accounts`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Create an Organization
         * @param {CreateOrganizationDTO} createOrganizationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganization(createOrganizationDTO: CreateOrganizationDTO, options: any = {}): RequestArgs {
            // verify required parameter 'createOrganizationDTO' is not null or undefined
            if (createOrganizationDTO === null || createOrganizationDTO === undefined) {
                throw new RequiredError('createOrganizationDTO','Required parameter createOrganizationDTO was null or undefined when calling createOrganization.');
            }
            const localVarPath = `/v2/organizations`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"CreateOrganizationDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createOrganizationDTO !== undefined ? createOrganizationDTO : {}) : (createOrganizationDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Disable product creation for an organization
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableProductCreation(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling disableProductCreation.');
            }
            const localVarPath = `/v2/organizations/{id}/disable`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Dismiss an organization message
         * @param {'featureBankAccounts' | 'warningBankAccounts'} messageId Message id
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissOrganizationMessage(messageId: 'featureBankAccounts' | 'warningBankAccounts', id: string, options: any = {}): RequestArgs {
            // verify required parameter 'messageId' is not null or undefined
            if (messageId === null || messageId === undefined) {
                throw new RequiredError('messageId','Required parameter messageId was null or undefined when calling dismissOrganizationMessage.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling dismissOrganizationMessage.');
            }
            const localVarPath = `/v2/organizations/{id}/messages/{messageId}/dismiss`
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Enable product creation for an organization
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableProductCreation(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling enableProductCreation.');
            }
            const localVarPath = `/v2/organizations/{id}/enable`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an Organization\'s Addresses
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAddressesByOrganizationId(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling fetchAddressesByOrganizationId.');
            }
            const localVarPath = `/v2/organizations/{id}/addresses`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an Organization\'s Landlords
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchLandlordsByOrganizationId(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling fetchLandlordsByOrganizationId.');
            }
            const localVarPath = `/v2/organizations/{id}/landlords`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an Organization\'s Organization Users
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchOrganizationUsersByOrganizationId(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling fetchOrganizationUsersByOrganizationId.');
            }
            const localVarPath = `/v2/organizations/{id}/organization-users`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an Organization\'s Properties
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPropertiesByOrganizationId(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling fetchPropertiesByOrganizationId.');
            }
            const localVarPath = `/v2/organizations/{id}/properties`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an Organization\'s Tenancies
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTenanciesByOrganizationId(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling fetchTenanciesByOrganizationId.');
            }
            const localVarPath = `/v2/organizations/{id}/tenancies`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an Organization\'s Users
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUsersByOrganizationId(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling fetchUsersByOrganizationId.');
            }
            const localVarPath = `/v2/organizations/{id}/users`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an Organization by id
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOrganizationById(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling findOrganizationById.');
            }
            const localVarPath = `/v2/organizations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an organization\'s cash deposit scheme
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCashDepositScheme(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getCashDepositScheme.');
            }
            const localVarPath = `/v2/organizations/{id}/cash-deposit-scheme`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an Organization\'s children by Organization id
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChildren(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getChildren.');
            }
            const localVarPath = `/v2/organizations/{id}/children`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get dashboard metrics for an Organization
         * @param {string} organizationId Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationMetrics(organizationId: string, options: any = {}): RequestArgs {
            // verify required parameter 'organizationId' is not null or undefined
            if (organizationId === null || organizationId === undefined) {
                throw new RequiredError('organizationId','Required parameter organizationId was null or undefined when calling getOrganizationMetrics.');
            }
            const localVarPath = `/v2/organizations/{organizationId}/metrics`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an organization\'s verticals
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationVerticals(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getOrganizationVerticals.');
            }
            const localVarPath = `/v2/organizations/{id}/verticals`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get an organization\'s organization recipients
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecipients(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getRecipients.');
            }
            const localVarPath = `/v2/organizations/{id}/recipients`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a User from an Organization
         * @param {string} id Organization id
         * @param {string} userId User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUser(id: string, userId: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling removeUser.');
            }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling removeUser.');
            }
            const localVarPath = `/v2/organizations/{id}/users/{userId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Search HubSpot companies by name
         * @param {string} query HubSpot company name search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchHubspotCompanies(query: string, options: any = {}): RequestArgs {
            // verify required parameter 'query' is not null or undefined
            if (query === null || query === undefined) {
                throw new RequiredError('query','Required parameter query was null or undefined when calling searchHubspotCompanies.');
            }
            const localVarPath = `/v2/organizations/hubspot-companies`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Search for an Organization by name
         * @param {string} organizationTypeId Organization type Id to filter to by
         * @param {number} page Page to start on (defaults to 1)
         * @param {number} size Size of result set to return (defaults to 15)
         * @param {string} [query] Search query
         * @param {string} [sortBy] Sort By to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrganization(organizationTypeId: string, page: number, size: number, query?: string, sortBy?: string, options: any = {}): RequestArgs {
            // verify required parameter 'organizationTypeId' is not null or undefined
            if (organizationTypeId === null || organizationTypeId === undefined) {
                throw new RequiredError('organizationTypeId','Required parameter organizationTypeId was null or undefined when calling searchOrganization.');
            }
            // verify required parameter 'page' is not null or undefined
            if (page === null || page === undefined) {
                throw new RequiredError('page','Required parameter page was null or undefined when calling searchOrganization.');
            }
            // verify required parameter 'size' is not null or undefined
            if (size === null || size === undefined) {
                throw new RequiredError('size','Required parameter size was null or undefined when calling searchOrganization.');
            }
            const localVarPath = `/v2/organizations`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (organizationTypeId !== undefined) {
                localVarQueryParameter['organizationTypeId'] = organizationTypeId;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update your landlord information completion through onboarding
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setLandlordInformationComplete(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling setLandlordInformationComplete.');
            }
            const localVarPath = `/v2/organizations/{id}/onboarding/landlord-information`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update your ast acceptance through onboarding
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateASTAcceptance(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateASTAcceptance.');
            }
            const localVarPath = `/v2/organizations/{id}/onboarding/ast`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update your informed landlords through onboarding
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInformedLandlords(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateInformedLandlords.');
            }
            const localVarPath = `/v2/organizations/{id}/onboarding/informed-landlords`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an Organization\'s settings by id
         * @param {string} id Organization id
         * @param {UpdateOrganizationDTO} updateOrganizationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganization(id: string, updateOrganizationDTO: UpdateOrganizationDTO, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateOrganization.');
            }
            // verify required parameter 'updateOrganizationDTO' is not null or undefined
            if (updateOrganizationDTO === null || updateOrganizationDTO === undefined) {
                throw new RequiredError('updateOrganizationDTO','Required parameter updateOrganizationDTO was null or undefined when calling updateOrganization.');
            }
            const localVarPath = `/v2/organizations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateOrganizationDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateOrganizationDTO !== undefined ? updateOrganizationDTO : {}) : (updateOrganizationDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an Organization\'s address
         * @param {string} id Organization id
         * @param {UpdateOrganizationAddressDTO} updateOrganizationAddressDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationAddress(id: string, updateOrganizationAddressDTO: UpdateOrganizationAddressDTO, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateOrganizationAddress.');
            }
            // verify required parameter 'updateOrganizationAddressDTO' is not null or undefined
            if (updateOrganizationAddressDTO === null || updateOrganizationAddressDTO === undefined) {
                throw new RequiredError('updateOrganizationAddressDTO','Required parameter updateOrganizationAddressDTO was null or undefined when calling updateOrganizationAddress.');
            }
            const localVarPath = `/v2/organizations/{id}/address`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateOrganizationAddressDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateOrganizationAddressDTO !== undefined ? updateOrganizationAddressDTO : {}) : (updateOrganizationAddressDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an Organization\'s commission rule by id
         * @param {string} id Organization id
         * @param {UpdateOrganizationCommissionRuleDTO} updateOrganizationCommissionRuleDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationCommissionRule(id: string, updateOrganizationCommissionRuleDTO: UpdateOrganizationCommissionRuleDTO, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateOrganizationCommissionRule.');
            }
            // verify required parameter 'updateOrganizationCommissionRuleDTO' is not null or undefined
            if (updateOrganizationCommissionRuleDTO === null || updateOrganizationCommissionRuleDTO === undefined) {
                throw new RequiredError('updateOrganizationCommissionRuleDTO','Required parameter updateOrganizationCommissionRuleDTO was null or undefined when calling updateOrganizationCommissionRule.');
            }
            const localVarPath = `/v2/organizations/{id}/commission-rule`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateOrganizationCommissionRuleDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateOrganizationCommissionRuleDTO !== undefined ? updateOrganizationCommissionRuleDTO : {}) : (updateOrganizationCommissionRuleDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an Organization\'s HubSpot ID by id
         * @param {string} id Organization id
         * @param {UpdateOrganizationHubspotIdDTO} updateOrganizationHubspotIdDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationHubspotId(id: string, updateOrganizationHubspotIdDTO: UpdateOrganizationHubspotIdDTO, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateOrganizationHubspotId.');
            }
            // verify required parameter 'updateOrganizationHubspotIdDTO' is not null or undefined
            if (updateOrganizationHubspotIdDTO === null || updateOrganizationHubspotIdDTO === undefined) {
                throw new RequiredError('updateOrganizationHubspotIdDTO','Required parameter updateOrganizationHubspotIdDTO was null or undefined when calling updateOrganizationHubspotId.');
            }
            const localVarPath = `/v2/organizations/{id}/hubspot-id`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateOrganizationHubspotIdDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateOrganizationHubspotIdDTO !== undefined ? updateOrganizationHubspotIdDTO : {}) : (updateOrganizationHubspotIdDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update whether an Organization sends the inventory confirmation at 72 hours
         * @param {string} id Organization id
         * @param {UpdateOrganizationInventoryConfirmationDelayDTO} updateOrganizationInventoryConfirmationDelayDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationInventoryConfirmationDelay(id: string, updateOrganizationInventoryConfirmationDelayDTO: UpdateOrganizationInventoryConfirmationDelayDTO, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateOrganizationInventoryConfirmationDelay.');
            }
            // verify required parameter 'updateOrganizationInventoryConfirmationDelayDTO' is not null or undefined
            if (updateOrganizationInventoryConfirmationDelayDTO === null || updateOrganizationInventoryConfirmationDelayDTO === undefined) {
                throw new RequiredError('updateOrganizationInventoryConfirmationDelayDTO','Required parameter updateOrganizationInventoryConfirmationDelayDTO was null or undefined when calling updateOrganizationInventoryConfirmationDelay.');
            }
            const localVarPath = `/v2/organizations/{id}/inventory-confirmation-delay`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateOrganizationInventoryConfirmationDelayDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateOrganizationInventoryConfirmationDelayDTO !== undefined ? updateOrganizationInventoryConfirmationDelayDTO : {}) : (updateOrganizationInventoryConfirmationDelayDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an Organization\'s name by id
         * @param {string} id Organization id
         * @param {UpdateOrganizationNameDTO} updateOrganizationNameDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationName(id: string, updateOrganizationNameDTO: UpdateOrganizationNameDTO, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateOrganizationName.');
            }
            // verify required parameter 'updateOrganizationNameDTO' is not null or undefined
            if (updateOrganizationNameDTO === null || updateOrganizationNameDTO === undefined) {
                throw new RequiredError('updateOrganizationNameDTO','Required parameter updateOrganizationNameDTO was null or undefined when calling updateOrganizationName.');
            }
            const localVarPath = `/v2/organizations/{id}/name`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateOrganizationNameDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateOrganizationNameDTO !== undefined ? updateOrganizationNameDTO : {}) : (updateOrganizationNameDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an Organization\'s notes
         * @param {string} id Organization id
         * @param {UpdateOrganizationNotesDTO} updateOrganizationNotesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationNotes(id: string, updateOrganizationNotesDTO: UpdateOrganizationNotesDTO, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateOrganizationNotes.');
            }
            // verify required parameter 'updateOrganizationNotesDTO' is not null or undefined
            if (updateOrganizationNotesDTO === null || updateOrganizationNotesDTO === undefined) {
                throw new RequiredError('updateOrganizationNotesDTO','Required parameter updateOrganizationNotesDTO was null or undefined when calling updateOrganizationNotes.');
            }
            const localVarPath = `/v2/organizations/{id}/notes`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateOrganizationNotesDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateOrganizationNotesDTO !== undefined ? updateOrganizationNotesDTO : {}) : (updateOrganizationNotesDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an Organization\'s organization group fields by id
         * @param {string} id Organization id
         * @param {UpdateOrganizationParentGroupsDTO} updateOrganizationParentGroupsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationParentGroups(id: string, updateOrganizationParentGroupsDTO: UpdateOrganizationParentGroupsDTO, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateOrganizationParentGroups.');
            }
            // verify required parameter 'updateOrganizationParentGroupsDTO' is not null or undefined
            if (updateOrganizationParentGroupsDTO === null || updateOrganizationParentGroupsDTO === undefined) {
                throw new RequiredError('updateOrganizationParentGroupsDTO','Required parameter updateOrganizationParentGroupsDTO was null or undefined when calling updateOrganizationParentGroups.');
            }
            const localVarPath = `/v2/organizations/{id}/parent-organization-groups`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateOrganizationParentGroupsDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateOrganizationParentGroupsDTO !== undefined ? updateOrganizationParentGroupsDTO : {}) : (updateOrganizationParentGroupsDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an Organization\'s policy cover cap by id
         * @param {string} id Organization id
         * @param {UpdateOrganizationPolicyCoverCapDTO} updateOrganizationPolicyCoverCapDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationPolicyCoverCap(id: string, updateOrganizationPolicyCoverCapDTO: UpdateOrganizationPolicyCoverCapDTO, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateOrganizationPolicyCoverCap.');
            }
            // verify required parameter 'updateOrganizationPolicyCoverCapDTO' is not null or undefined
            if (updateOrganizationPolicyCoverCapDTO === null || updateOrganizationPolicyCoverCapDTO === undefined) {
                throw new RequiredError('updateOrganizationPolicyCoverCapDTO','Required parameter updateOrganizationPolicyCoverCapDTO was null or undefined when calling updateOrganizationPolicyCoverCap.');
            }
            const localVarPath = `/v2/organizations/{id}/policy-cover-cap`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateOrganizationPolicyCoverCapDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateOrganizationPolicyCoverCapDTO !== undefined ? updateOrganizationPolicyCoverCapDTO : {}) : (updateOrganizationPolicyCoverCapDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an Organization\'s pricing rule by id
         * @param {string} id Organization id
         * @param {UpdateOrganizationPricingRuleDTO} updateOrganizationPricingRuleDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationPricingRule(id: string, updateOrganizationPricingRuleDTO: UpdateOrganizationPricingRuleDTO, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateOrganizationPricingRule.');
            }
            // verify required parameter 'updateOrganizationPricingRuleDTO' is not null or undefined
            if (updateOrganizationPricingRuleDTO === null || updateOrganizationPricingRuleDTO === undefined) {
                throw new RequiredError('updateOrganizationPricingRuleDTO','Required parameter updateOrganizationPricingRuleDTO was null or undefined when calling updateOrganizationPricingRule.');
            }
            const localVarPath = `/v2/organizations/{id}/pricing-rule`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateOrganizationPricingRuleDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateOrganizationPricingRuleDTO !== undefined ? updateOrganizationPricingRuleDTO : {}) : (updateOrganizationPricingRuleDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Confirm terms acceptance through onboarding and completes onboarding
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTermsAccepted(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateTermsAccepted.');
            }
            const localVarPath = `/v2/organizations/{id}/onboarding/terms`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update your company through onboarding
         * @param {string} id Organization id
         * @param {UpdateYourCompanyDTO} updateYourCompanyDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateYourCompany(id: string, updateYourCompanyDTO: UpdateYourCompanyDTO, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateYourCompany.');
            }
            // verify required parameter 'updateYourCompanyDTO' is not null or undefined
            if (updateYourCompanyDTO === null || updateYourCompanyDTO === undefined) {
                throw new RequiredError('updateYourCompanyDTO','Required parameter updateYourCompanyDTO was null or undefined when calling updateYourCompany.');
            }
            const localVarPath = `/v2/organizations/{id}/onboarding/your-company`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateYourCompanyDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateYourCompanyDTO !== undefined ? updateYourCompanyDTO : {}) : (updateYourCompanyDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update your welcome landlord completion through onboarding
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        welcomeLandlord(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling welcomeLandlord.');
            }
            const localVarPath = `/v2/organizations/{id}/onboarding/welcome-landlord`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationsApi - functional programming interface
 * @export
 */
export const OrganizationsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Confirm bank accounts collected through onboarding
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmBankAccounts(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationDTO> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).confirmBankAccounts(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Create an Organization
         * @param {CreateOrganizationDTO} createOrganizationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganization(createOrganizationDTO: CreateOrganizationDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationDTO> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).createOrganization(createOrganizationDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Disable product creation for an organization
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableProductCreation(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationDTO> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).disableProductCreation(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Dismiss an organization message
         * @param {'featureBankAccounts' | 'warningBankAccounts'} messageId Message id
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissOrganizationMessage(messageId: 'featureBankAccounts' | 'warningBankAccounts', id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationDTO> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).dismissOrganizationMessage(messageId, id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Enable product creation for an organization
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableProductCreation(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationDTO> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).enableProductCreation(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get an Organization\'s Addresses
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAddressesByOrganizationId(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AddressDTO>> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).fetchAddressesByOrganizationId(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get an Organization\'s Landlords
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchLandlordsByOrganizationId(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LandlordDTO>> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).fetchLandlordsByOrganizationId(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get an Organization\'s Organization Users
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchOrganizationUsersByOrganizationId(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationUserDTO>> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).fetchOrganizationUsersByOrganizationId(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get an Organization\'s Properties
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPropertiesByOrganizationId(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PropertyDTO>> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).fetchPropertiesByOrganizationId(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get an Organization\'s Tenancies
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTenanciesByOrganizationId(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenancyDTO>> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).fetchTenanciesByOrganizationId(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get an Organization\'s Users
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUsersByOrganizationId(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDTO>> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).fetchUsersByOrganizationId(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get an Organization by id
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOrganizationById(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationWithCashDepositDTO> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).findOrganizationById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get an organization\'s cash deposit scheme
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCashDepositScheme(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationCashDepositSchemeDTO> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).getCashDepositScheme(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get an Organization\'s children by Organization id
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChildren(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationDTO>> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).getChildren(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get dashboard metrics for an Organization
         * @param {string} organizationId Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationMetrics(organizationId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationMetricsDTO> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).getOrganizationMetrics(organizationId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get an organization\'s verticals
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationVerticals(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationVerticalDTO>> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).getOrganizationVerticals(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get an organization\'s organization recipients
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecipients(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OrganizationRecipientDTO>> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).getRecipients(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete a User from an Organization
         * @param {string} id Organization id
         * @param {string} userId User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUser(id: string, userId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).removeUser(id, userId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Search HubSpot companies by name
         * @param {string} query HubSpot company name search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchHubspotCompanies(query: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchHubspotCompaniesResultsDTO> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).searchHubspotCompanies(query, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Search for an Organization by name
         * @param {string} organizationTypeId Organization type Id to filter to by
         * @param {number} page Page to start on (defaults to 1)
         * @param {number} size Size of result set to return (defaults to 15)
         * @param {string} [query] Search query
         * @param {string} [sortBy] Sort By to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrganization(organizationTypeId: string, page: number, size: number, query?: string, sortBy?: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchOrganizationResultsDTO> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).searchOrganization(organizationTypeId, page, size, query, sortBy, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update your landlord information completion through onboarding
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setLandlordInformationComplete(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationDTO> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).setLandlordInformationComplete(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update your ast acceptance through onboarding
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateASTAcceptance(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationDTO> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateASTAcceptance(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update your informed landlords through onboarding
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInformedLandlords(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationDTO> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateInformedLandlords(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update an Organization\'s settings by id
         * @param {string} id Organization id
         * @param {UpdateOrganizationDTO} updateOrganizationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganization(id: string, updateOrganizationDTO: UpdateOrganizationDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationDTO> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateOrganization(id, updateOrganizationDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update an Organization\'s address
         * @param {string} id Organization id
         * @param {UpdateOrganizationAddressDTO} updateOrganizationAddressDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationAddress(id: string, updateOrganizationAddressDTO: UpdateOrganizationAddressDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationDTO> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateOrganizationAddress(id, updateOrganizationAddressDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update an Organization\'s commission rule by id
         * @param {string} id Organization id
         * @param {UpdateOrganizationCommissionRuleDTO} updateOrganizationCommissionRuleDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationCommissionRule(id: string, updateOrganizationCommissionRuleDTO: UpdateOrganizationCommissionRuleDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationDTO> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateOrganizationCommissionRule(id, updateOrganizationCommissionRuleDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update an Organization\'s HubSpot ID by id
         * @param {string} id Organization id
         * @param {UpdateOrganizationHubspotIdDTO} updateOrganizationHubspotIdDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationHubspotId(id: string, updateOrganizationHubspotIdDTO: UpdateOrganizationHubspotIdDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationDTO> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateOrganizationHubspotId(id, updateOrganizationHubspotIdDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update whether an Organization sends the inventory confirmation at 72 hours
         * @param {string} id Organization id
         * @param {UpdateOrganizationInventoryConfirmationDelayDTO} updateOrganizationInventoryConfirmationDelayDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationInventoryConfirmationDelay(id: string, updateOrganizationInventoryConfirmationDelayDTO: UpdateOrganizationInventoryConfirmationDelayDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationDTO> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateOrganizationInventoryConfirmationDelay(id, updateOrganizationInventoryConfirmationDelayDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update an Organization\'s name by id
         * @param {string} id Organization id
         * @param {UpdateOrganizationNameDTO} updateOrganizationNameDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationName(id: string, updateOrganizationNameDTO: UpdateOrganizationNameDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationDTO> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateOrganizationName(id, updateOrganizationNameDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update an Organization\'s notes
         * @param {string} id Organization id
         * @param {UpdateOrganizationNotesDTO} updateOrganizationNotesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationNotes(id: string, updateOrganizationNotesDTO: UpdateOrganizationNotesDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationDTO> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateOrganizationNotes(id, updateOrganizationNotesDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update an Organization\'s organization group fields by id
         * @param {string} id Organization id
         * @param {UpdateOrganizationParentGroupsDTO} updateOrganizationParentGroupsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationParentGroups(id: string, updateOrganizationParentGroupsDTO: UpdateOrganizationParentGroupsDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationDTO> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateOrganizationParentGroups(id, updateOrganizationParentGroupsDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update an Organization\'s policy cover cap by id
         * @param {string} id Organization id
         * @param {UpdateOrganizationPolicyCoverCapDTO} updateOrganizationPolicyCoverCapDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationPolicyCoverCap(id: string, updateOrganizationPolicyCoverCapDTO: UpdateOrganizationPolicyCoverCapDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationDTO> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateOrganizationPolicyCoverCap(id, updateOrganizationPolicyCoverCapDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update an Organization\'s pricing rule by id
         * @param {string} id Organization id
         * @param {UpdateOrganizationPricingRuleDTO} updateOrganizationPricingRuleDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationPricingRule(id: string, updateOrganizationPricingRuleDTO: UpdateOrganizationPricingRuleDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationDTO> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateOrganizationPricingRule(id, updateOrganizationPricingRuleDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Confirm terms acceptance through onboarding and completes onboarding
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTermsAccepted(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationDTO> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateTermsAccepted(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update your company through onboarding
         * @param {string} id Organization id
         * @param {UpdateYourCompanyDTO} updateYourCompanyDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateYourCompany(id: string, updateYourCompanyDTO: UpdateYourCompanyDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationDTO> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateYourCompany(id, updateYourCompanyDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update your welcome landlord completion through onboarding
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        welcomeLandlord(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationDTO> {
            const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).welcomeLandlord(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * OrganizationsApi - factory interface
 * @export
 */
export const OrganizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Confirm bank accounts collected through onboarding
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmBankAccounts(id: string, options?: any) {
            return OrganizationsApiFp(configuration).confirmBankAccounts(id, options)(axios, basePath);
        },
        /**
         * Create an Organization
         * @param {CreateOrganizationDTO} createOrganizationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganization(createOrganizationDTO: CreateOrganizationDTO, options?: any) {
            return OrganizationsApiFp(configuration).createOrganization(createOrganizationDTO, options)(axios, basePath);
        },
        /**
         * Disable product creation for an organization
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableProductCreation(id: string, options?: any) {
            return OrganizationsApiFp(configuration).disableProductCreation(id, options)(axios, basePath);
        },
        /**
         * Dismiss an organization message
         * @param {'featureBankAccounts' | 'warningBankAccounts'} messageId Message id
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dismissOrganizationMessage(messageId: 'featureBankAccounts' | 'warningBankAccounts', id: string, options?: any) {
            return OrganizationsApiFp(configuration).dismissOrganizationMessage(messageId, id, options)(axios, basePath);
        },
        /**
         * Enable product creation for an organization
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableProductCreation(id: string, options?: any) {
            return OrganizationsApiFp(configuration).enableProductCreation(id, options)(axios, basePath);
        },
        /**
         * Get an Organization\'s Addresses
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchAddressesByOrganizationId(id: string, options?: any) {
            return OrganizationsApiFp(configuration).fetchAddressesByOrganizationId(id, options)(axios, basePath);
        },
        /**
         * Get an Organization\'s Landlords
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchLandlordsByOrganizationId(id: string, options?: any) {
            return OrganizationsApiFp(configuration).fetchLandlordsByOrganizationId(id, options)(axios, basePath);
        },
        /**
         * Get an Organization\'s Organization Users
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchOrganizationUsersByOrganizationId(id: string, options?: any) {
            return OrganizationsApiFp(configuration).fetchOrganizationUsersByOrganizationId(id, options)(axios, basePath);
        },
        /**
         * Get an Organization\'s Properties
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchPropertiesByOrganizationId(id: string, options?: any) {
            return OrganizationsApiFp(configuration).fetchPropertiesByOrganizationId(id, options)(axios, basePath);
        },
        /**
         * Get an Organization\'s Tenancies
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchTenanciesByOrganizationId(id: string, options?: any) {
            return OrganizationsApiFp(configuration).fetchTenanciesByOrganizationId(id, options)(axios, basePath);
        },
        /**
         * Get an Organization\'s Users
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fetchUsersByOrganizationId(id: string, options?: any) {
            return OrganizationsApiFp(configuration).fetchUsersByOrganizationId(id, options)(axios, basePath);
        },
        /**
         * Get an Organization by id
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOrganizationById(id: string, options?: any) {
            return OrganizationsApiFp(configuration).findOrganizationById(id, options)(axios, basePath);
        },
        /**
         * Get an organization\'s cash deposit scheme
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCashDepositScheme(id: string, options?: any) {
            return OrganizationsApiFp(configuration).getCashDepositScheme(id, options)(axios, basePath);
        },
        /**
         * Get an Organization\'s children by Organization id
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChildren(id: string, options?: any) {
            return OrganizationsApiFp(configuration).getChildren(id, options)(axios, basePath);
        },
        /**
         * Get dashboard metrics for an Organization
         * @param {string} organizationId Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationMetrics(organizationId: string, options?: any) {
            return OrganizationsApiFp(configuration).getOrganizationMetrics(organizationId, options)(axios, basePath);
        },
        /**
         * Get an organization\'s verticals
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationVerticals(id: string, options?: any) {
            return OrganizationsApiFp(configuration).getOrganizationVerticals(id, options)(axios, basePath);
        },
        /**
         * Get an organization\'s organization recipients
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecipients(id: string, options?: any) {
            return OrganizationsApiFp(configuration).getRecipients(id, options)(axios, basePath);
        },
        /**
         * Delete a User from an Organization
         * @param {string} id Organization id
         * @param {string} userId User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUser(id: string, userId: string, options?: any) {
            return OrganizationsApiFp(configuration).removeUser(id, userId, options)(axios, basePath);
        },
        /**
         * Search HubSpot companies by name
         * @param {string} query HubSpot company name search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchHubspotCompanies(query: string, options?: any) {
            return OrganizationsApiFp(configuration).searchHubspotCompanies(query, options)(axios, basePath);
        },
        /**
         * Search for an Organization by name
         * @param {string} organizationTypeId Organization type Id to filter to by
         * @param {number} page Page to start on (defaults to 1)
         * @param {number} size Size of result set to return (defaults to 15)
         * @param {string} [query] Search query
         * @param {string} [sortBy] Sort By to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrganization(organizationTypeId: string, page: number, size: number, query?: string, sortBy?: string, options?: any) {
            return OrganizationsApiFp(configuration).searchOrganization(organizationTypeId, page, size, query, sortBy, options)(axios, basePath);
        },
        /**
         * Update your landlord information completion through onboarding
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setLandlordInformationComplete(id: string, options?: any) {
            return OrganizationsApiFp(configuration).setLandlordInformationComplete(id, options)(axios, basePath);
        },
        /**
         * Update your ast acceptance through onboarding
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateASTAcceptance(id: string, options?: any) {
            return OrganizationsApiFp(configuration).updateASTAcceptance(id, options)(axios, basePath);
        },
        /**
         * Update your informed landlords through onboarding
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateInformedLandlords(id: string, options?: any) {
            return OrganizationsApiFp(configuration).updateInformedLandlords(id, options)(axios, basePath);
        },
        /**
         * Update an Organization\'s settings by id
         * @param {string} id Organization id
         * @param {UpdateOrganizationDTO} updateOrganizationDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganization(id: string, updateOrganizationDTO: UpdateOrganizationDTO, options?: any) {
            return OrganizationsApiFp(configuration).updateOrganization(id, updateOrganizationDTO, options)(axios, basePath);
        },
        /**
         * Update an Organization\'s address
         * @param {string} id Organization id
         * @param {UpdateOrganizationAddressDTO} updateOrganizationAddressDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationAddress(id: string, updateOrganizationAddressDTO: UpdateOrganizationAddressDTO, options?: any) {
            return OrganizationsApiFp(configuration).updateOrganizationAddress(id, updateOrganizationAddressDTO, options)(axios, basePath);
        },
        /**
         * Update an Organization\'s commission rule by id
         * @param {string} id Organization id
         * @param {UpdateOrganizationCommissionRuleDTO} updateOrganizationCommissionRuleDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationCommissionRule(id: string, updateOrganizationCommissionRuleDTO: UpdateOrganizationCommissionRuleDTO, options?: any) {
            return OrganizationsApiFp(configuration).updateOrganizationCommissionRule(id, updateOrganizationCommissionRuleDTO, options)(axios, basePath);
        },
        /**
         * Update an Organization\'s HubSpot ID by id
         * @param {string} id Organization id
         * @param {UpdateOrganizationHubspotIdDTO} updateOrganizationHubspotIdDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationHubspotId(id: string, updateOrganizationHubspotIdDTO: UpdateOrganizationHubspotIdDTO, options?: any) {
            return OrganizationsApiFp(configuration).updateOrganizationHubspotId(id, updateOrganizationHubspotIdDTO, options)(axios, basePath);
        },
        /**
         * Update whether an Organization sends the inventory confirmation at 72 hours
         * @param {string} id Organization id
         * @param {UpdateOrganizationInventoryConfirmationDelayDTO} updateOrganizationInventoryConfirmationDelayDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationInventoryConfirmationDelay(id: string, updateOrganizationInventoryConfirmationDelayDTO: UpdateOrganizationInventoryConfirmationDelayDTO, options?: any) {
            return OrganizationsApiFp(configuration).updateOrganizationInventoryConfirmationDelay(id, updateOrganizationInventoryConfirmationDelayDTO, options)(axios, basePath);
        },
        /**
         * Update an Organization\'s name by id
         * @param {string} id Organization id
         * @param {UpdateOrganizationNameDTO} updateOrganizationNameDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationName(id: string, updateOrganizationNameDTO: UpdateOrganizationNameDTO, options?: any) {
            return OrganizationsApiFp(configuration).updateOrganizationName(id, updateOrganizationNameDTO, options)(axios, basePath);
        },
        /**
         * Update an Organization\'s notes
         * @param {string} id Organization id
         * @param {UpdateOrganizationNotesDTO} updateOrganizationNotesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationNotes(id: string, updateOrganizationNotesDTO: UpdateOrganizationNotesDTO, options?: any) {
            return OrganizationsApiFp(configuration).updateOrganizationNotes(id, updateOrganizationNotesDTO, options)(axios, basePath);
        },
        /**
         * Update an Organization\'s organization group fields by id
         * @param {string} id Organization id
         * @param {UpdateOrganizationParentGroupsDTO} updateOrganizationParentGroupsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationParentGroups(id: string, updateOrganizationParentGroupsDTO: UpdateOrganizationParentGroupsDTO, options?: any) {
            return OrganizationsApiFp(configuration).updateOrganizationParentGroups(id, updateOrganizationParentGroupsDTO, options)(axios, basePath);
        },
        /**
         * Update an Organization\'s policy cover cap by id
         * @param {string} id Organization id
         * @param {UpdateOrganizationPolicyCoverCapDTO} updateOrganizationPolicyCoverCapDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationPolicyCoverCap(id: string, updateOrganizationPolicyCoverCapDTO: UpdateOrganizationPolicyCoverCapDTO, options?: any) {
            return OrganizationsApiFp(configuration).updateOrganizationPolicyCoverCap(id, updateOrganizationPolicyCoverCapDTO, options)(axios, basePath);
        },
        /**
         * Update an Organization\'s pricing rule by id
         * @param {string} id Organization id
         * @param {UpdateOrganizationPricingRuleDTO} updateOrganizationPricingRuleDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrganizationPricingRule(id: string, updateOrganizationPricingRuleDTO: UpdateOrganizationPricingRuleDTO, options?: any) {
            return OrganizationsApiFp(configuration).updateOrganizationPricingRule(id, updateOrganizationPricingRuleDTO, options)(axios, basePath);
        },
        /**
         * Confirm terms acceptance through onboarding and completes onboarding
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTermsAccepted(id: string, options?: any) {
            return OrganizationsApiFp(configuration).updateTermsAccepted(id, options)(axios, basePath);
        },
        /**
         * Update your company through onboarding
         * @param {string} id Organization id
         * @param {UpdateYourCompanyDTO} updateYourCompanyDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateYourCompany(id: string, updateYourCompanyDTO: UpdateYourCompanyDTO, options?: any) {
            return OrganizationsApiFp(configuration).updateYourCompany(id, updateYourCompanyDTO, options)(axios, basePath);
        },
        /**
         * Update your welcome landlord completion through onboarding
         * @param {string} id Organization id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        welcomeLandlord(id: string, options?: any) {
            return OrganizationsApiFp(configuration).welcomeLandlord(id, options)(axios, basePath);
        },
    };
};

/**
 * OrganizationsApi - interface
 * @export
 * @interface OrganizationsApi
 */
export interface OrganizationsApiInterface {
    /**
     * Confirm bank accounts collected through onboarding
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    confirmBankAccounts(id: string, options?: any): AxiosPromise<OrganizationDTO>;

    /**
     * Create an Organization
     * @param {CreateOrganizationDTO} createOrganizationDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    createOrganization(createOrganizationDTO: CreateOrganizationDTO, options?: any): AxiosPromise<OrganizationDTO>;

    /**
     * Disable product creation for an organization
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    disableProductCreation(id: string, options?: any): AxiosPromise<OrganizationDTO>;

    /**
     * Dismiss an organization message
     * @param {'featureBankAccounts' | 'warningBankAccounts'} messageId Message id
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    dismissOrganizationMessage(messageId: 'featureBankAccounts' | 'warningBankAccounts', id: string, options?: any): AxiosPromise<OrganizationDTO>;

    /**
     * Enable product creation for an organization
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    enableProductCreation(id: string, options?: any): AxiosPromise<OrganizationDTO>;

    /**
     * Get an Organization\'s Addresses
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    fetchAddressesByOrganizationId(id: string, options?: any): AxiosPromise<Array<AddressDTO>>;

    /**
     * Get an Organization\'s Landlords
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    fetchLandlordsByOrganizationId(id: string, options?: any): AxiosPromise<Array<LandlordDTO>>;

    /**
     * Get an Organization\'s Organization Users
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    fetchOrganizationUsersByOrganizationId(id: string, options?: any): AxiosPromise<Array<OrganizationUserDTO>>;

    /**
     * Get an Organization\'s Properties
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    fetchPropertiesByOrganizationId(id: string, options?: any): AxiosPromise<Array<PropertyDTO>>;

    /**
     * Get an Organization\'s Tenancies
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    fetchTenanciesByOrganizationId(id: string, options?: any): AxiosPromise<Array<TenancyDTO>>;

    /**
     * Get an Organization\'s Users
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    fetchUsersByOrganizationId(id: string, options?: any): AxiosPromise<Array<UserDTO>>;

    /**
     * Get an Organization by id
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    findOrganizationById(id: string, options?: any): AxiosPromise<OrganizationWithCashDepositDTO>;

    /**
     * Get an organization\'s cash deposit scheme
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    getCashDepositScheme(id: string, options?: any): AxiosPromise<OrganizationCashDepositSchemeDTO>;

    /**
     * Get an Organization\'s children by Organization id
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    getChildren(id: string, options?: any): AxiosPromise<Array<OrganizationDTO>>;

    /**
     * Get dashboard metrics for an Organization
     * @param {string} organizationId Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    getOrganizationMetrics(organizationId: string, options?: any): AxiosPromise<OrganizationMetricsDTO>;

    /**
     * Get an organization\'s verticals
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    getOrganizationVerticals(id: string, options?: any): AxiosPromise<Array<OrganizationVerticalDTO>>;

    /**
     * Get an organization\'s organization recipients
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    getRecipients(id: string, options?: any): AxiosPromise<Array<OrganizationRecipientDTO>>;

    /**
     * Delete a User from an Organization
     * @param {string} id Organization id
     * @param {string} userId User id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    removeUser(id: string, userId: string, options?: any): AxiosPromise<object>;

    /**
     * Search HubSpot companies by name
     * @param {string} query HubSpot company name search term
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    searchHubspotCompanies(query: string, options?: any): AxiosPromise<SearchHubspotCompaniesResultsDTO>;

    /**
     * Search for an Organization by name
     * @param {string} organizationTypeId Organization type Id to filter to by
     * @param {number} page Page to start on (defaults to 1)
     * @param {number} size Size of result set to return (defaults to 15)
     * @param {string} [query] Search query
     * @param {string} [sortBy] Sort By to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    searchOrganization(organizationTypeId: string, page: number, size: number, query?: string, sortBy?: string, options?: any): AxiosPromise<SearchOrganizationResultsDTO>;

    /**
     * Update your landlord information completion through onboarding
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    setLandlordInformationComplete(id: string, options?: any): AxiosPromise<OrganizationDTO>;

    /**
     * Update your ast acceptance through onboarding
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    updateASTAcceptance(id: string, options?: any): AxiosPromise<OrganizationDTO>;

    /**
     * Update your informed landlords through onboarding
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    updateInformedLandlords(id: string, options?: any): AxiosPromise<OrganizationDTO>;

    /**
     * Update an Organization\'s settings by id
     * @param {string} id Organization id
     * @param {UpdateOrganizationDTO} updateOrganizationDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    updateOrganization(id: string, updateOrganizationDTO: UpdateOrganizationDTO, options?: any): AxiosPromise<OrganizationDTO>;

    /**
     * Update an Organization\'s address
     * @param {string} id Organization id
     * @param {UpdateOrganizationAddressDTO} updateOrganizationAddressDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    updateOrganizationAddress(id: string, updateOrganizationAddressDTO: UpdateOrganizationAddressDTO, options?: any): AxiosPromise<OrganizationDTO>;

    /**
     * Update an Organization\'s commission rule by id
     * @param {string} id Organization id
     * @param {UpdateOrganizationCommissionRuleDTO} updateOrganizationCommissionRuleDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    updateOrganizationCommissionRule(id: string, updateOrganizationCommissionRuleDTO: UpdateOrganizationCommissionRuleDTO, options?: any): AxiosPromise<OrganizationDTO>;

    /**
     * Update an Organization\'s HubSpot ID by id
     * @param {string} id Organization id
     * @param {UpdateOrganizationHubspotIdDTO} updateOrganizationHubspotIdDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    updateOrganizationHubspotId(id: string, updateOrganizationHubspotIdDTO: UpdateOrganizationHubspotIdDTO, options?: any): AxiosPromise<OrganizationDTO>;

    /**
     * Update whether an Organization sends the inventory confirmation at 72 hours
     * @param {string} id Organization id
     * @param {UpdateOrganizationInventoryConfirmationDelayDTO} updateOrganizationInventoryConfirmationDelayDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    updateOrganizationInventoryConfirmationDelay(id: string, updateOrganizationInventoryConfirmationDelayDTO: UpdateOrganizationInventoryConfirmationDelayDTO, options?: any): AxiosPromise<OrganizationDTO>;

    /**
     * Update an Organization\'s name by id
     * @param {string} id Organization id
     * @param {UpdateOrganizationNameDTO} updateOrganizationNameDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    updateOrganizationName(id: string, updateOrganizationNameDTO: UpdateOrganizationNameDTO, options?: any): AxiosPromise<OrganizationDTO>;

    /**
     * Update an Organization\'s notes
     * @param {string} id Organization id
     * @param {UpdateOrganizationNotesDTO} updateOrganizationNotesDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    updateOrganizationNotes(id: string, updateOrganizationNotesDTO: UpdateOrganizationNotesDTO, options?: any): AxiosPromise<OrganizationDTO>;

    /**
     * Update an Organization\'s organization group fields by id
     * @param {string} id Organization id
     * @param {UpdateOrganizationParentGroupsDTO} updateOrganizationParentGroupsDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    updateOrganizationParentGroups(id: string, updateOrganizationParentGroupsDTO: UpdateOrganizationParentGroupsDTO, options?: any): AxiosPromise<OrganizationDTO>;

    /**
     * Update an Organization\'s policy cover cap by id
     * @param {string} id Organization id
     * @param {UpdateOrganizationPolicyCoverCapDTO} updateOrganizationPolicyCoverCapDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    updateOrganizationPolicyCoverCap(id: string, updateOrganizationPolicyCoverCapDTO: UpdateOrganizationPolicyCoverCapDTO, options?: any): AxiosPromise<OrganizationDTO>;

    /**
     * Update an Organization\'s pricing rule by id
     * @param {string} id Organization id
     * @param {UpdateOrganizationPricingRuleDTO} updateOrganizationPricingRuleDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    updateOrganizationPricingRule(id: string, updateOrganizationPricingRuleDTO: UpdateOrganizationPricingRuleDTO, options?: any): AxiosPromise<OrganizationDTO>;

    /**
     * Confirm terms acceptance through onboarding and completes onboarding
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    updateTermsAccepted(id: string, options?: any): AxiosPromise<OrganizationDTO>;

    /**
     * Update your company through onboarding
     * @param {string} id Organization id
     * @param {UpdateYourCompanyDTO} updateYourCompanyDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    updateYourCompany(id: string, updateYourCompanyDTO: UpdateYourCompanyDTO, options?: any): AxiosPromise<OrganizationDTO>;

    /**
     * Update your welcome landlord completion through onboarding
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApiInterface
     */
    welcomeLandlord(id: string, options?: any): AxiosPromise<OrganizationDTO>;

}

/**
 * OrganizationsApi - object-oriented interface
 * @export
 * @class OrganizationsApi
 * @extends {BaseAPI}
 */
export class OrganizationsApi extends BaseAPI implements OrganizationsApiInterface {
    /**
     * Confirm bank accounts collected through onboarding
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public confirmBankAccounts(id: string, options?: any) {
        return OrganizationsApiFp(this.configuration).confirmBankAccounts(id, options)(this.axios, this.basePath);
    }

    /**
     * Create an Organization
     * @param {CreateOrganizationDTO} createOrganizationDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public createOrganization(createOrganizationDTO: CreateOrganizationDTO, options?: any) {
        return OrganizationsApiFp(this.configuration).createOrganization(createOrganizationDTO, options)(this.axios, this.basePath);
    }

    /**
     * Disable product creation for an organization
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public disableProductCreation(id: string, options?: any) {
        return OrganizationsApiFp(this.configuration).disableProductCreation(id, options)(this.axios, this.basePath);
    }

    /**
     * Dismiss an organization message
     * @param {'featureBankAccounts' | 'warningBankAccounts'} messageId Message id
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public dismissOrganizationMessage(messageId: 'featureBankAccounts' | 'warningBankAccounts', id: string, options?: any) {
        return OrganizationsApiFp(this.configuration).dismissOrganizationMessage(messageId, id, options)(this.axios, this.basePath);
    }

    /**
     * Enable product creation for an organization
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public enableProductCreation(id: string, options?: any) {
        return OrganizationsApiFp(this.configuration).enableProductCreation(id, options)(this.axios, this.basePath);
    }

    /**
     * Get an Organization\'s Addresses
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public fetchAddressesByOrganizationId(id: string, options?: any) {
        return OrganizationsApiFp(this.configuration).fetchAddressesByOrganizationId(id, options)(this.axios, this.basePath);
    }

    /**
     * Get an Organization\'s Landlords
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public fetchLandlordsByOrganizationId(id: string, options?: any) {
        return OrganizationsApiFp(this.configuration).fetchLandlordsByOrganizationId(id, options)(this.axios, this.basePath);
    }

    /**
     * Get an Organization\'s Organization Users
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public fetchOrganizationUsersByOrganizationId(id: string, options?: any) {
        return OrganizationsApiFp(this.configuration).fetchOrganizationUsersByOrganizationId(id, options)(this.axios, this.basePath);
    }

    /**
     * Get an Organization\'s Properties
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public fetchPropertiesByOrganizationId(id: string, options?: any) {
        return OrganizationsApiFp(this.configuration).fetchPropertiesByOrganizationId(id, options)(this.axios, this.basePath);
    }

    /**
     * Get an Organization\'s Tenancies
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public fetchTenanciesByOrganizationId(id: string, options?: any) {
        return OrganizationsApiFp(this.configuration).fetchTenanciesByOrganizationId(id, options)(this.axios, this.basePath);
    }

    /**
     * Get an Organization\'s Users
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public fetchUsersByOrganizationId(id: string, options?: any) {
        return OrganizationsApiFp(this.configuration).fetchUsersByOrganizationId(id, options)(this.axios, this.basePath);
    }

    /**
     * Get an Organization by id
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public findOrganizationById(id: string, options?: any) {
        return OrganizationsApiFp(this.configuration).findOrganizationById(id, options)(this.axios, this.basePath);
    }

    /**
     * Get an organization\'s cash deposit scheme
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getCashDepositScheme(id: string, options?: any) {
        return OrganizationsApiFp(this.configuration).getCashDepositScheme(id, options)(this.axios, this.basePath);
    }

    /**
     * Get an Organization\'s children by Organization id
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getChildren(id: string, options?: any) {
        return OrganizationsApiFp(this.configuration).getChildren(id, options)(this.axios, this.basePath);
    }

    /**
     * Get dashboard metrics for an Organization
     * @param {string} organizationId Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getOrganizationMetrics(organizationId: string, options?: any) {
        return OrganizationsApiFp(this.configuration).getOrganizationMetrics(organizationId, options)(this.axios, this.basePath);
    }

    /**
     * Get an organization\'s verticals
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getOrganizationVerticals(id: string, options?: any) {
        return OrganizationsApiFp(this.configuration).getOrganizationVerticals(id, options)(this.axios, this.basePath);
    }

    /**
     * Get an organization\'s organization recipients
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getRecipients(id: string, options?: any) {
        return OrganizationsApiFp(this.configuration).getRecipients(id, options)(this.axios, this.basePath);
    }

    /**
     * Delete a User from an Organization
     * @param {string} id Organization id
     * @param {string} userId User id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public removeUser(id: string, userId: string, options?: any) {
        return OrganizationsApiFp(this.configuration).removeUser(id, userId, options)(this.axios, this.basePath);
    }

    /**
     * Search HubSpot companies by name
     * @param {string} query HubSpot company name search term
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public searchHubspotCompanies(query: string, options?: any) {
        return OrganizationsApiFp(this.configuration).searchHubspotCompanies(query, options)(this.axios, this.basePath);
    }

    /**
     * Search for an Organization by name
     * @param {string} organizationTypeId Organization type Id to filter to by
     * @param {number} page Page to start on (defaults to 1)
     * @param {number} size Size of result set to return (defaults to 15)
     * @param {string} [query] Search query
     * @param {string} [sortBy] Sort By to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public searchOrganization(organizationTypeId: string, page: number, size: number, query?: string, sortBy?: string, options?: any) {
        return OrganizationsApiFp(this.configuration).searchOrganization(organizationTypeId, page, size, query, sortBy, options)(this.axios, this.basePath);
    }

    /**
     * Update your landlord information completion through onboarding
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public setLandlordInformationComplete(id: string, options?: any) {
        return OrganizationsApiFp(this.configuration).setLandlordInformationComplete(id, options)(this.axios, this.basePath);
    }

    /**
     * Update your ast acceptance through onboarding
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public updateASTAcceptance(id: string, options?: any) {
        return OrganizationsApiFp(this.configuration).updateASTAcceptance(id, options)(this.axios, this.basePath);
    }

    /**
     * Update your informed landlords through onboarding
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public updateInformedLandlords(id: string, options?: any) {
        return OrganizationsApiFp(this.configuration).updateInformedLandlords(id, options)(this.axios, this.basePath);
    }

    /**
     * Update an Organization\'s settings by id
     * @param {string} id Organization id
     * @param {UpdateOrganizationDTO} updateOrganizationDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public updateOrganization(id: string, updateOrganizationDTO: UpdateOrganizationDTO, options?: any) {
        return OrganizationsApiFp(this.configuration).updateOrganization(id, updateOrganizationDTO, options)(this.axios, this.basePath);
    }

    /**
     * Update an Organization\'s address
     * @param {string} id Organization id
     * @param {UpdateOrganizationAddressDTO} updateOrganizationAddressDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public updateOrganizationAddress(id: string, updateOrganizationAddressDTO: UpdateOrganizationAddressDTO, options?: any) {
        return OrganizationsApiFp(this.configuration).updateOrganizationAddress(id, updateOrganizationAddressDTO, options)(this.axios, this.basePath);
    }

    /**
     * Update an Organization\'s commission rule by id
     * @param {string} id Organization id
     * @param {UpdateOrganizationCommissionRuleDTO} updateOrganizationCommissionRuleDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public updateOrganizationCommissionRule(id: string, updateOrganizationCommissionRuleDTO: UpdateOrganizationCommissionRuleDTO, options?: any) {
        return OrganizationsApiFp(this.configuration).updateOrganizationCommissionRule(id, updateOrganizationCommissionRuleDTO, options)(this.axios, this.basePath);
    }

    /**
     * Update an Organization\'s HubSpot ID by id
     * @param {string} id Organization id
     * @param {UpdateOrganizationHubspotIdDTO} updateOrganizationHubspotIdDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public updateOrganizationHubspotId(id: string, updateOrganizationHubspotIdDTO: UpdateOrganizationHubspotIdDTO, options?: any) {
        return OrganizationsApiFp(this.configuration).updateOrganizationHubspotId(id, updateOrganizationHubspotIdDTO, options)(this.axios, this.basePath);
    }

    /**
     * Update whether an Organization sends the inventory confirmation at 72 hours
     * @param {string} id Organization id
     * @param {UpdateOrganizationInventoryConfirmationDelayDTO} updateOrganizationInventoryConfirmationDelayDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public updateOrganizationInventoryConfirmationDelay(id: string, updateOrganizationInventoryConfirmationDelayDTO: UpdateOrganizationInventoryConfirmationDelayDTO, options?: any) {
        return OrganizationsApiFp(this.configuration).updateOrganizationInventoryConfirmationDelay(id, updateOrganizationInventoryConfirmationDelayDTO, options)(this.axios, this.basePath);
    }

    /**
     * Update an Organization\'s name by id
     * @param {string} id Organization id
     * @param {UpdateOrganizationNameDTO} updateOrganizationNameDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public updateOrganizationName(id: string, updateOrganizationNameDTO: UpdateOrganizationNameDTO, options?: any) {
        return OrganizationsApiFp(this.configuration).updateOrganizationName(id, updateOrganizationNameDTO, options)(this.axios, this.basePath);
    }

    /**
     * Update an Organization\'s notes
     * @param {string} id Organization id
     * @param {UpdateOrganizationNotesDTO} updateOrganizationNotesDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public updateOrganizationNotes(id: string, updateOrganizationNotesDTO: UpdateOrganizationNotesDTO, options?: any) {
        return OrganizationsApiFp(this.configuration).updateOrganizationNotes(id, updateOrganizationNotesDTO, options)(this.axios, this.basePath);
    }

    /**
     * Update an Organization\'s organization group fields by id
     * @param {string} id Organization id
     * @param {UpdateOrganizationParentGroupsDTO} updateOrganizationParentGroupsDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public updateOrganizationParentGroups(id: string, updateOrganizationParentGroupsDTO: UpdateOrganizationParentGroupsDTO, options?: any) {
        return OrganizationsApiFp(this.configuration).updateOrganizationParentGroups(id, updateOrganizationParentGroupsDTO, options)(this.axios, this.basePath);
    }

    /**
     * Update an Organization\'s policy cover cap by id
     * @param {string} id Organization id
     * @param {UpdateOrganizationPolicyCoverCapDTO} updateOrganizationPolicyCoverCapDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public updateOrganizationPolicyCoverCap(id: string, updateOrganizationPolicyCoverCapDTO: UpdateOrganizationPolicyCoverCapDTO, options?: any) {
        return OrganizationsApiFp(this.configuration).updateOrganizationPolicyCoverCap(id, updateOrganizationPolicyCoverCapDTO, options)(this.axios, this.basePath);
    }

    /**
     * Update an Organization\'s pricing rule by id
     * @param {string} id Organization id
     * @param {UpdateOrganizationPricingRuleDTO} updateOrganizationPricingRuleDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public updateOrganizationPricingRule(id: string, updateOrganizationPricingRuleDTO: UpdateOrganizationPricingRuleDTO, options?: any) {
        return OrganizationsApiFp(this.configuration).updateOrganizationPricingRule(id, updateOrganizationPricingRuleDTO, options)(this.axios, this.basePath);
    }

    /**
     * Confirm terms acceptance through onboarding and completes onboarding
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public updateTermsAccepted(id: string, options?: any) {
        return OrganizationsApiFp(this.configuration).updateTermsAccepted(id, options)(this.axios, this.basePath);
    }

    /**
     * Update your company through onboarding
     * @param {string} id Organization id
     * @param {UpdateYourCompanyDTO} updateYourCompanyDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public updateYourCompany(id: string, updateYourCompanyDTO: UpdateYourCompanyDTO, options?: any) {
        return OrganizationsApiFp(this.configuration).updateYourCompany(id, updateYourCompanyDTO, options)(this.axios, this.basePath);
    }

    /**
     * Update your welcome landlord completion through onboarding
     * @param {string} id Organization id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public welcomeLandlord(id: string, options?: any) {
        return OrganizationsApiFp(this.configuration).welcomeLandlord(id, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for OrganizationsApi
 * Import individual functions for optimal bundle size
 */
/**
 * Confirm bank accounts collected through onboarding
 * @param {string} id Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function confirmBankAccounts(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationDTO> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).confirmBankAccounts(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Create an Organization
 * @param {CreateOrganizationDTO} createOrganizationDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function createOrganization(
    createOrganizationDTO: CreateOrganizationDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationDTO> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).createOrganization(createOrganizationDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Disable product creation for an organization
 * @param {string} id Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function disableProductCreation(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationDTO> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).disableProductCreation(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Dismiss an organization message
 * @param {'featureBankAccounts' | 'warningBankAccounts'} messageId Message id
 * @param {string} id Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function dismissOrganizationMessage(
    messageId: 'featureBankAccounts' | 'warningBankAccounts',
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationDTO> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).dismissOrganizationMessage(messageId, id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Enable product creation for an organization
 * @param {string} id Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function enableProductCreation(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationDTO> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).enableProductCreation(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get an Organization\'s Addresses
 * @param {string} id Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function fetchAddressesByOrganizationId(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<AddressDTO>> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).fetchAddressesByOrganizationId(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get an Organization\'s Landlords
 * @param {string} id Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function fetchLandlordsByOrganizationId(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<LandlordDTO>> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).fetchLandlordsByOrganizationId(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get an Organization\'s Organization Users
 * @param {string} id Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function fetchOrganizationUsersByOrganizationId(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<OrganizationUserDTO>> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).fetchOrganizationUsersByOrganizationId(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get an Organization\'s Properties
 * @param {string} id Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function fetchPropertiesByOrganizationId(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<PropertyDTO>> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).fetchPropertiesByOrganizationId(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get an Organization\'s Tenancies
 * @param {string} id Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function fetchTenanciesByOrganizationId(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<TenancyDTO>> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).fetchTenanciesByOrganizationId(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get an Organization\'s Users
 * @param {string} id Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function fetchUsersByOrganizationId(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<UserDTO>> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).fetchUsersByOrganizationId(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get an Organization by id
 * @param {string} id Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function findOrganizationById(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationWithCashDepositDTO> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).findOrganizationById(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get an organization\'s cash deposit scheme
 * @param {string} id Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getCashDepositScheme(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationCashDepositSchemeDTO> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).getCashDepositScheme(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get an Organization\'s children by Organization id
 * @param {string} id Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getChildren(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<OrganizationDTO>> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).getChildren(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get dashboard metrics for an Organization
 * @param {string} organizationId Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getOrganizationMetrics(
    organizationId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationMetricsDTO> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).getOrganizationMetrics(organizationId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get an organization\'s verticals
 * @param {string} id Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getOrganizationVerticals(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<OrganizationVerticalDTO>> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).getOrganizationVerticals(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get an organization\'s organization recipients
 * @param {string} id Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getRecipients(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<OrganizationRecipientDTO>> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).getRecipients(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Delete a User from an Organization
 * @param {string} id Organization id
 * @param {string} userId User id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function removeUser(
    id: string,
    userId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).removeUser(id, userId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Search HubSpot companies by name
 * @param {string} query HubSpot company name search term
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function searchHubspotCompanies(
    query: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<SearchHubspotCompaniesResultsDTO> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).searchHubspotCompanies(query, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Search for an Organization by name
 * @param {string} organizationTypeId Organization type Id to filter to by
 * @param {number} page Page to start on (defaults to 1)
 * @param {number} size Size of result set to return (defaults to 15)
 * @param {string} [query] Search query
 * @param {string} [sortBy] Sort By to filter by
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function searchOrganization(
    organizationTypeId: string,
    page: number,
    size: number,
    query?: string,
    sortBy?: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<SearchOrganizationResultsDTO> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).searchOrganization(organizationTypeId, page, size, query, sortBy, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update your landlord information completion through onboarding
 * @param {string} id Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function setLandlordInformationComplete(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationDTO> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).setLandlordInformationComplete(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update your ast acceptance through onboarding
 * @param {string} id Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateASTAcceptance(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationDTO> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateASTAcceptance(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update your informed landlords through onboarding
 * @param {string} id Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateInformedLandlords(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationDTO> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateInformedLandlords(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update an Organization\'s settings by id
 * @param {string} id Organization id
 * @param {UpdateOrganizationDTO} updateOrganizationDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateOrganization(
    id: string,
    updateOrganizationDTO: UpdateOrganizationDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationDTO> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateOrganization(id, updateOrganizationDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update an Organization\'s address
 * @param {string} id Organization id
 * @param {UpdateOrganizationAddressDTO} updateOrganizationAddressDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateOrganizationAddress(
    id: string,
    updateOrganizationAddressDTO: UpdateOrganizationAddressDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationDTO> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateOrganizationAddress(id, updateOrganizationAddressDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update an Organization\'s commission rule by id
 * @param {string} id Organization id
 * @param {UpdateOrganizationCommissionRuleDTO} updateOrganizationCommissionRuleDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateOrganizationCommissionRule(
    id: string,
    updateOrganizationCommissionRuleDTO: UpdateOrganizationCommissionRuleDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationDTO> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateOrganizationCommissionRule(id, updateOrganizationCommissionRuleDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update an Organization\'s HubSpot ID by id
 * @param {string} id Organization id
 * @param {UpdateOrganizationHubspotIdDTO} updateOrganizationHubspotIdDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateOrganizationHubspotId(
    id: string,
    updateOrganizationHubspotIdDTO: UpdateOrganizationHubspotIdDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationDTO> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateOrganizationHubspotId(id, updateOrganizationHubspotIdDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update whether an Organization sends the inventory confirmation at 72 hours
 * @param {string} id Organization id
 * @param {UpdateOrganizationInventoryConfirmationDelayDTO} updateOrganizationInventoryConfirmationDelayDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateOrganizationInventoryConfirmationDelay(
    id: string,
    updateOrganizationInventoryConfirmationDelayDTO: UpdateOrganizationInventoryConfirmationDelayDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationDTO> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateOrganizationInventoryConfirmationDelay(id, updateOrganizationInventoryConfirmationDelayDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update an Organization\'s name by id
 * @param {string} id Organization id
 * @param {UpdateOrganizationNameDTO} updateOrganizationNameDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateOrganizationName(
    id: string,
    updateOrganizationNameDTO: UpdateOrganizationNameDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationDTO> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateOrganizationName(id, updateOrganizationNameDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update an Organization\'s notes
 * @param {string} id Organization id
 * @param {UpdateOrganizationNotesDTO} updateOrganizationNotesDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateOrganizationNotes(
    id: string,
    updateOrganizationNotesDTO: UpdateOrganizationNotesDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationDTO> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateOrganizationNotes(id, updateOrganizationNotesDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update an Organization\'s organization group fields by id
 * @param {string} id Organization id
 * @param {UpdateOrganizationParentGroupsDTO} updateOrganizationParentGroupsDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateOrganizationParentGroups(
    id: string,
    updateOrganizationParentGroupsDTO: UpdateOrganizationParentGroupsDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationDTO> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateOrganizationParentGroups(id, updateOrganizationParentGroupsDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update an Organization\'s policy cover cap by id
 * @param {string} id Organization id
 * @param {UpdateOrganizationPolicyCoverCapDTO} updateOrganizationPolicyCoverCapDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateOrganizationPolicyCoverCap(
    id: string,
    updateOrganizationPolicyCoverCapDTO: UpdateOrganizationPolicyCoverCapDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationDTO> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateOrganizationPolicyCoverCap(id, updateOrganizationPolicyCoverCapDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update an Organization\'s pricing rule by id
 * @param {string} id Organization id
 * @param {UpdateOrganizationPricingRuleDTO} updateOrganizationPricingRuleDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateOrganizationPricingRule(
    id: string,
    updateOrganizationPricingRuleDTO: UpdateOrganizationPricingRuleDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationDTO> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateOrganizationPricingRule(id, updateOrganizationPricingRuleDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Confirm terms acceptance through onboarding and completes onboarding
 * @param {string} id Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateTermsAccepted(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationDTO> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateTermsAccepted(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update your company through onboarding
 * @param {string} id Organization id
 * @param {UpdateYourCompanyDTO} updateYourCompanyDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateYourCompany(
    id: string,
    updateYourCompanyDTO: UpdateYourCompanyDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationDTO> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).updateYourCompany(id, updateYourCompanyDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update your welcome landlord completion through onboarding
 * @param {string} id Organization id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function welcomeLandlord(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationDTO> {
    const localVarAxiosArgs = OrganizationsApiAxiosParamCreator(configuration).welcomeLandlord(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

